import clsx from 'clsx';
import React, { memo, use, useCallback, useEffect, useMemo, useState } from 'react';
import { ProdottoType, StageDataType, TipsType } from '../types';
import { useTranslation } from 'react-i18next';
import useHeaderContainer from '@/hook/useHeaderContainer';
import useBreakPoint from '@/hook/useBreakPoint';
import Divider from '@/components/core/divider/Divider';
import { Prodotti } from '@/models/interfaces/pages/bodies/detail/itinerario';
import StageCard from './StageCard';
import { EntityType } from '@/models/entity-type/EntityType';
import { set } from 'date-fns';

interface StageListProps {
  stages: StageDataType[];
  className?: string;
  mapOffsetHeight?: number;
  isMapExpanded?: boolean;

  selectedItem: ProdottoType | null;
  onSelectItem?: (item: ProdottoType | null) => void;

  onGoto: (id: string) => void;
  onUpdatePins: (items: TipsType) => void;
}

const transition = 'transition-all duration-300';

const StageList = ({
  stages,
  className,
  mapOffsetHeight = 100,
  selectedItem,
  isMapExpanded,
  onSelectItem,
  onGoto,
  onUpdatePins,
}: StageListProps) => {
  const [expanded, setExpanded] = useState(true);

  const [currentCardId, setCurrentCardId] = useState<number | null>(null);

  const { t } = useTranslation();

  const { height: headerHeight } = useHeaderContainer();

  const { greaterThanLg } = useBreakPoint();

  // const handleCardClick = useCallback(
  //   (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
  //     if (!greaterThanLg) return;

  //     setExpanded(!expanded);
  //     const element = e.currentTarget.closest('.itinerary-card');

  //     if (!expanded && greaterThanLg && element) {
  //       element.scrollIntoView({
  //         behavior: 'smooth',
  //         block: 'start',
  //       });
  //     }
  //   },
  //   [expanded, greaterThanLg],
  // );

  const tipsData = useMemo(() => {
    return stages?.map((itinerary, index) => {
      const { agriturismi, poi, cantine, eventi, ristoranti, frantoi, ristorazione } = itinerary || {};

      const cantineEFrantoi = [
        // ...(cantine ?? []).map((item) => ({ ...item, type: EntityType.CANTINE })),
        ...(frantoi ?? []),
      ];

      const doveMangiare = [...(agriturismi ?? []), ...(ristorazione ?? [])];
      const cosaVedere = [...(poi ?? [])];

      const eventiData = [...(eventi ?? [])];

      const tips = {
        cantineEFrantoi: cantineEFrantoi.slice(0, 20),
        doveMangiare: doveMangiare.slice(0, 20),
        cosaVedere: cosaVedere.slice(0, 10),
        eventiData: eventiData.slice(0, 20),
      };

      return tips;
    });
  }, [stages]);

  const onSelectItemHandler = useCallback(
    (item: Prodotti | null, cardId: number) => {
      if (!item) return;

      onSelectItem?.({
        id: String(item?.id),
        title: item?.title ?? '',
        excerpt: item?.excerpt ?? '',
        permalink: item?.permalink ?? '',
        image: {
          url: item?.image?.url ?? '',
          title: item?.image?.title ?? '',
        },
        lat: item?.point?.lat ?? 0,
        lng: item?.point?.lng ?? 0,
        url: item?.url ?? '',
      });
    },
    [currentCardId, onSelectItem],
  );

  // useEffect(() => {
  //   if (!greaterThanLg && expanded) {
  //     setExpanded(false);
  //   }
  // }, []);

  return (
    <div
      className={clsx('flex max-w-full flex-col overflow-hidden rounded-r-xl lg:mb-[50vh]', transition, {
        'lg:ml-10 lg:max-w-md': !expanded,
        // 'mx-4 lg:mx-0 lg:max-w-lg': expanded,
        'mx-4 lg:ml-10 lg:max-w-md xl:max-w-xl': expanded,
      })}
    >
      {stages?.map((stage, index) => {
        const isLastCard = index === stages.length - 1;

        return (
          <div key={stage.id + index}>
            <StageCard
              cardId={index}
              currentCardId={currentCardId}
              mapOffsetHeight={mapOffsetHeight}
              stage={stage}
              expanded={expanded}
              onGoto={onGoto}
              onUpdatePins={onUpdatePins}
              onSelectItemHandler={onSelectItemHandler}
              onWaypoint={() => setCurrentCardId(index)}
              tipsData={tipsData[index]}
              greaterThanLg={greaterThanLg}
              headerHeight={headerHeight}
              selectedItem={selectedItem}
              transition={transition}
              isMapExpanded={isMapExpanded}
            />

            <Divider
              className={clsx('my-10 w-full', {
                hidden: isLastCard || greaterThanLg,
              })}
            />
          </div>
        );
      })}
    </div>
  );
};

export default memo(StageList);
